import {PasswordReset} from "./passwordReset.model";
import {MatchesField} from "../../validators/matchesField.validator";
import {IsNotEmpty} from "class-validator";

class PasswordForm extends PasswordReset {
    @MatchesField('password', {message: "Your passwords do not match"})
    @IsNotEmpty({message: "Please confirm your password"})
    passwordRepeat: string;
}

export { PasswordForm }